import React from "react";
const selfieImage = require("./images/selfie-image.svg");

export default function SelfieSearch({
  openSelfieUploadPopup,
  imageThumbnail,
  removeSelfie
}: {
  openSelfieUploadPopup: Function;
  imageThumbnail: string | null;
  removeSelfie: Function;
}) {
  return (
    <div
      className={`geo-btn org-selfie-btn${
        !!imageThumbnail ? "orgevents-selfie-selected" : ""
      }`}
      onClick={() => openSelfieUploadPopup()}
    >
      <div>
        {"  "}
        {!imageThumbnail ? (
          <>
            <img
              src={selfieImage}
              className="orgevents-selfie-svg"
              alt="Selfie Image"
            />
            <b>UPLOAD SELFIE</b>
          </>
        ) : (
          <>
            <div
              className="orgevents-img-uploaded"
              style={{
                backgroundImage: "url(" + imageThumbnail + ")"
              }}
            ></div>
            <b className="chng-selfie">CHANGE SELFIE</b>
          </>
        )}
      </div>
      {!!imageThumbnail && (
        <div
          className="remove-selfie"
          onClick={e => {
            e.stopPropagation();
            removeSelfie();
          }}
        >
          ×
        </div>
      )}
    </div>
  );
}
